/**
 * Regulatory approval status — helpers over ApprovalStatus enum.
 */

import { ApprovalStatus } from "./regulatory/regulatory.type";
import { createStatusHelpers } from "./statusHelpers";

export { ApprovalStatus };
export const REGULATORY_APPROVAL_STATUS = ApprovalStatus;

const helpers = createStatusHelpers(
  ApprovalStatus as unknown as Record<string, ApprovalStatus>,
  ApprovalStatus.PENDING,
  {
    Approved: ApprovalStatus.APPROVED,
    Pending: ApprovalStatus.PENDING,
    Expired: ApprovalStatus.EXPIRED,
    "Renewal Required": ApprovalStatus.RENEWAL_REQUIRED,
  },
);

export const REGULATORY_APPROVAL_STATUS_VALUES = helpers.VALUES;
export const tryNormalizeRegulatoryApprovalStatus = helpers.tryNormalize;
export const normalizeRegulatoryApprovalStatus = helpers.normalize;
export const isRegulatoryApprovalStatus = helpers.isStatus;
export const isAnyRegulatoryApprovalStatus = helpers.isAnyStatus;
